/**
 * FloatingVoiceButton — bouton flottant style conciergerie premium.
 *
 * Visible en bas à droite sur toutes les pages (sauf checkout/admin).
 * Discret au repos, prend vie au survol avec un halo doré qui pulse.
 */
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Phone, Sparkles } from "lucide-react";
import PremiumPhoneButton from "@/components/PremiumPhoneButton";

const HIDDEN_PATHS = ["/login", "/register", "/paiement", "/payment", "/checkout", "/claim/"];

export default function FloatingVoiceButton() {
  const { pathname } = useLocation();
  const [hovered, setHovered] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 600);
    return () => clearTimeout(t);
  }, []);

  if (HIDDEN_PATHS.some(p => pathname.startsWith(p))) return null;
  if (pathname.startsWith("/admin") || pathname.startsWith("/expert/")) return null;
  // FAB visible aussi pour les visiteurs non connectés (mode guest intake).

  return (
    <>
      <div
        className={`fixed bottom-6 right-6 z-40 transition-all duration-700 ${
          mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
        }`}
        data-testid="floating-voice-fab"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="relative">
          {/* Tooltip premium */}
          <div
            className={`absolute bottom-full right-0 mb-3 bg-[#031B12] text-white text-xs px-3.5 py-2.5 rounded-lg shadow-xl whitespace-nowrap pointer-events-none transition-all duration-300 ${
              hovered ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
            }`}
          >
            <Sparkles className="inline w-3 h-3 text-[#F5C400] mr-1.5" />
            <span className="font-medium">Assistant vocal IA CONFILEX</span>
            <div className="text-[10px] text-white/60 mt-0.5">Cliquez pour être rappelé</div>
            <div className="absolute top-full right-5 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[#031B12]"></div>
          </div>

          {/* Halo qui pulse */}
          <div
            className="absolute inset-0 rounded-full bg-[#F5C400] animate-ping"
            style={{ animationDuration: "3s", opacity: 0.18 }}
          ></div>

          {/* Bouton principal */}
          <button
            onClick={() => setModalOpen(true)}
            data-testid="floating-voice-trigger"
            aria-label="Assistant vocal CONFILEX"
            className="relative w-14 h-14 rounded-full bg-gradient-to-br from-[#031B12] to-[#063D25] shadow-2xl shadow-[#031B12]/30 flex items-center justify-center border border-[#F5C400]/40 hover:scale-105 transition-transform group"
          >
            <Phone className="w-5 h-5 text-[#F5C400] group-hover:rotate-12 transition-transform" />
          </button>
        </div>
      </div>

      {/* Modale contrôlée */}
      <PremiumPhoneButton
        externalOpen={modalOpen}
        onExternalClose={() => setModalOpen(false)}
      />
    </>
  );
}
